"use client";

import { Button } from "@/components/ui/button";
import { useTour } from "@/context/TourContext";
import {
  getCurrentModuleTour,
  hasTourForCurrentRoute,
} from "@/utils/tour-utils";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import { LuBookOpen, LuPlay } from "react-icons/lu";

export const SmartTourButton: React.FC = () => {
  const pathname = usePathname();
  const { startTour, getTourProgress } = useTour();
  const [currentTour, setCurrentTour] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadCurrentTour = async () => {
      if (!hasTourForCurrentRoute(pathname)) {
        setCurrentTour(null);
        return;
      }

      setIsLoading(true);
      try {
        const tour = await getCurrentModuleTour(pathname);
        setCurrentTour(tour);
      } catch (error) {
        console.error("Error loading current tour:", error);
        setCurrentTour(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadCurrentTour();
  }, [pathname]);

  const handleStartTour = async () => {
    if (!currentTour) return;

    await startTour(currentTour.id);
  };

  // Don't render if no tour available for current route
  if (!currentTour) return null;

  const isCompleted = getTourProgress(currentTour.id);

  return (
    <Button
      onClick={handleStartTour}
      size="sm"
      disabled={isLoading}
      className="gap-2"
    >
      {isLoading ? (
        <LuBookOpen className="h-4 w-4 animate-pulse" />
      ) : (
        <LuPlay className="h-4 w-4" />
      )}
      {isCompleted
        ? `Repetir tour ${currentTour.name.toLowerCase()}`
        : `Tour ${currentTour.name.toLowerCase()}`}
    </Button>
  );
};
